export default __webpack_public_path__ + "static/media/heartIcon_active_white.3039e363.svg";